import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WidgetHeaderComponent } from '../widget-header/widget-header.component';
import { FormControl } from '@angular/forms';
import { SelectItem, SelectMode } from '../../../shared/components/select-menu/select-menu.component';
import { RibbonComponent } from '../../my-campaigns-screen/ribbon/ribbon.component';
import { NgIf } from '@angular/common';
import { AskPolarisWidgetConfig } from '../../copilot/types';

@Component({
  selector: 'app-widget-container',
  imports: [WidgetHeaderComponent, RibbonComponent, NgIf],
  templateUrl: './widget-container.component.html',
  styleUrl: './widget-container.component.scss'
})
export class WidgetContainerComponent<T = string> {

  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() tooltip: string = '';
  @Input() selectOptions: SelectItem<T>[] = [];
  @Input() control!: FormControl<T | T[]>;
  @Input() selectMode: SelectMode = SelectMode.MULTI;
  @Input() iconPath: string = '';
  @Input() placeholder: string = '';
  @Input() searchable: boolean = true;
  @Input() selectDisabled: boolean = false;
  @Input() compareWith!: (option1: any, option2: any) => boolean;
  @Input() minHeight?: number;
  @Input() alignCenter?: boolean = true;
  @Input() disabledByLength: boolean = false;
  @Input() showRibbon: boolean = false;

  @Input() selectWidth: string = '100%';
  @Input() selectSearchPlaceholder: string = 'Search item';
  @Input() hideSelected: boolean = false;
  @Input() selectDropdownWideWidth: boolean = false;

  @Input() showPlaceholderIcon: boolean = false;
  @Input() selectAllAndClearOptions: boolean = false;
  @Input() showAllSelected: boolean = false;
  @Input() showSelectedIcon: boolean = true;
  @Input() showPlaceholderAllSelected: boolean = false;

  @Input() secondControl!: FormControl<any>;
  @Input() secondSelectOptions: SelectItem<T>[] = [];
  @Input() secondPlaceholder: string = '';
  @Input() secondSelectWidth: string = '100%';
  @Input() secondSelectSearchPlaceholder: string = 'Search item';

  @Input() askPolarisWidget: AskPolarisWidgetConfig | undefined;
  @Input() selectedMetrics?: string[];
  @Input() showVolumeFilter: boolean = false;
  @Output() apply = new EventEmitter<void>();
  @Output() volumeFilterApplied = new EventEmitter<number | null>();

  onApply() {
    this.apply.emit();
  }

  onVolumeFilterApplied(value: number | null) {
    this.volumeFilterApplied.emit(value);
  }
}
